module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/typography/blockquote/blockquote.component.scss
// module id = ./src/app/features/typography/blockquote/blockquote.component.scss
// module chunks = main